import { Component } from '@angular/core';
import { FpKeyFeaturesComponent } from '../common/fp-key-features/fp-key-features.component';
import { FpWidgetsComponent } from '../common/fp-widgets/fp-widgets.component';
import { FpFaqComponent } from '../common/fp-faq/fp-faq.component';
import { FpContactComponent } from '../common/fp-contact/fp-contact.component';
import { FpCtaComponent } from '../common/fp-cta/fp-cta.component';
import { FpBannerComponent } from '../common/fp-banner/fp-banner.component';
import { TranslateModule } from '@ngx-translate/core';
import { FpProcessComponent } from '../common/fp-process/fp-process.component';

@Component({
    selector: 'app-home',
    imports: [FpBannerComponent, FpKeyFeaturesComponent, FpProcessComponent, FpWidgetsComponent, FpFaqComponent, FpContactComponent, FpCtaComponent, TranslateModule],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {}